/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {BaseEntity} from './base-entity';
import {ObjectCategory} from './object-category';
import {Function} from './function';

export class ObjectDefinition extends BaseEntity {
  parentId: number;
  type: string;
  category: ObjectCategory;
  owner: string;
  singleton: boolean;
  functions: Function[];
}
